module.exports = __webpack_public_path__ + "img/image9.e345302a.png";